import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { gsap } from 'gsap';
import { FiCalendar, FiArrowRight } from 'react-icons/fi';
import './HeroBanner.css';

const HeroBanner = () => {
  const navigate = useNavigate();
  const heroRef = useRef(null);

  useEffect(() => {
    // Clean entry animation for title and text
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

      tl.fromTo('.hb-tag', { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.6 })
        .fromTo('.hb-title', { opacity: 0, y: 35 }, { opacity: 1, y: 0, duration: 0.8 }, '-=0.4')
        .fromTo('.hb-desc', { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.7 }, '-=0.5')
        .fromTo('.hb-actions', { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.6 }, '-=0.5')
        .fromTo('.hb-scroll-indicator', { opacity: 0 }, { opacity: 1, duration: 0.5 }, '-=0.3');
    }, heroRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="hb-wrapper" ref={heroRef}>
      {/* Background Banner Image with Gradient Mask Overlay */}
      <div
        className="hb-bg-banner"
        style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/img4.jpeg')` }}
      />
      <div className="hb-bg-overlay" />

      <div className="hb-container">
        {/* Full-width Left-Aligned Content Overlay */}
        <div className="hb-content">
          <div className="hb-tag">
            <span className="pulse-dot"></span>
            COMPASSIONATE HEALTHCARE
          </div>

          <h1 className="hb-title">
            Advanced Care, <br />
            <span>Right Beside You</span>
          </h1>

          <p className="hb-desc">
            Trusted healthcare for every stage of life with expert doctors, advanced medical facilities and comprehensive treatment services at Swarup Hospital, Kolhapur.
          </p>

          {/* Action CTAs */}
          <div className="hb-actions">
            <button
              className="hb-btn-primary"
              onClick={() => navigate('/appointments')}
            >
              <FiCalendar /> Book Appointment
            </button>
            <button
              className="hb-btn-secondary"
              onClick={() => navigate('/services')}
            >
              Explore Services <FiArrowRight />
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Down Indicator */}
      <div className="hb-scroll-indicator">
        <span className="mouse-wheel"></span>
        <span className="mouse-text">Scroll Down</span>
      </div>
    </section>
  );
};

export default HeroBanner;
